import { Tab } from '@vgrubs/components';
import styled from 'styled-components';

/**
 * A filter tab that takes a third of the row on mobile but never less than
 * its label on one line, so a long count scrolls the row instead of wrapping.
 */
export const FilterTab = styled(Tab)`
  @media (max-width: 800px) {
    flex-shrink: 0;
    white-space: nowrap;
    min-width: max-content;
  }
`;
